import React, { FC } from 'react';
import { ContainerLarge } from '../../components/base/grid';
import RegistrationComponent from '../../components/myPost/registration';
import pageWrapper from '../../hoc/pageWrapper';
import IMyShipmentsRegistrationViewModel from '../../interfaces/myShipments/myShipmentsRegistration';

interface Props {
	page: IMyShipmentsRegistrationViewModel;
}

const MyShipmentsRegistration: FC<Props> = ({ page }) => {
	return (
		<ContainerLarge>
			<RegistrationComponent page={page} />
		</ContainerLarge>
	);
};

export default pageWrapper(MyShipmentsRegistration);
